import { render } from "./ForgetPasswordPage.vue?vue&type=template&id=2afaa8cf&ts=true"
import script from "./ForgetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ForgetPasswordPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__